import { Axios } from "../../../util";
import axios from "axios";


const policyMaintenanceAPI = async (requestList) => {
  try {
    const res = await Axios.post('/api/policy/policyMaintenance', {
      requests: requestList, 
    });
    return res.data;
  } catch (error) {
    console.error("Error occurred while calling policyMaintenance API!", error);
    throw error;
  }
};

const updateRequestPersonalAPI = async (requestList) => {
  try {
    const res = await Axios.post('/api/request/updateRequestPersonal', requestList);
    return res.data;
  } catch (error) {
    console.error("Error occurred while calling policyMaintenance API!", error);
    throw error;
  }
};


export { policyMaintenanceAPI, updateRequestPersonalAPI};
